import IconButton from '../../../../../components/IconButton';
import { Table, Row, Col, Container } from 'react-bootstrap';
import { StatusMapping } from '../../../../../data/statusMapping';
import { StatusActionPair } from '../../../../../data/statusActionPairs';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const TraineeshipInfoTable = ({ data, size, typeOfStudent }) => {
    const { t } = useTranslation('translation', { keyPrefix: "traineeships.singleView.traineeshipInfo" });

    const formatDate = (string) => {
        var options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(string).toLocaleDateString("en-UK", options);
    }

    const getPlannedPeriod = () => {
        let startDate, endDate;

        // Check if final_table_a2 has dates, otherwise use table_a
        if (data?.traineeship?.final_table_a2?.field_tr_final_tbl_a2_sta_period) {
            startDate = data?.traineeship?.final_table_a2?.field_tr_final_tbl_a2_sta_period;
            endDate = data?.traineeship?.final_table_a2?.field_tr_final_tbl_a2_end_period;
        } else {
            startDate = data?.traineeship?.table_a?.field_tr_pre_tbl_a_sta_period;
            endDate = data?.traineeship?.table_a?.field_tr_pre_tbl_a_end_period;
        }
        
        if (startDate && endDate) {
            return `${formatDate(startDate)} - ${formatDate(endDate)}`;
        }
        return '';
    }

    return (
        <>
            {(size !== "md" && size !== "lg" && size !== "xl" && size !== "xxl") ?
                <div className={`${(StatusActionPair["traineeship-typeOfStudent-1-" + data?.traineeship?.field_tr_status] ?
                    "action-" + StatusActionPair["traineeship-typeOfStudent-1-" + data?.traineeship?.field_tr_status] : "")
                    }`}>
                    <Container>
                        <Row style={{ paddingLeft: 10 }}>
                            <Col>
                                <Row style={{ paddingTop: 15, paddingBottom: 2 }}><Col className='border-hidden label-style' xs={4}>ID:</Col><Col xs={6}>{data?.traineeship?.traineeship_id || ''}</Col></Row>
                                <Row style={{ paddingTop: 15, paddingBottom: 2 }}><Col className='border-hidden label-style' xs={4}>STATUS:</Col><Col xs={6}>{StatusMapping[data?.traineeship?.field_tr_status] || ''}</Col></Row>
                                <Row style={{ paddingTop: 15, paddingBottom: 2 }}><Col className='border-hidden label-style' xs={4}>PLANNED PERIOD:</Col><Col xs={6}>{getPlannedPeriod()}</Col></Row>
                                <Row style={{ paddingTop: 15, paddingBottom: 2 }}><Col className='border-hidden label-style' xs={4}>CREATED:</Col><Col xs={6}>{data?.traineeship?.created ? new Date(data?.traineeship?.created).toLocaleDateString() + " - " + new Date(data?.traineeship?.created).toLocaleTimeString() : ''}</Col></Row>
                                <Row style={{ paddingTop: 15, paddingBottom: 10 }}><Col className='border-hidden label-style text-end'>
                                    <Link to={`/traineeships/outgoing/export/${data?.traineeship?.traineeshipID}`} target="_blank">
                                        <IconButton
                                            variant="download"
                                            title="Download All files"
                                        />
                                    </Link>
                                </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                :
                <div className={`${(StatusActionPair["traineeship-typeOfStudent-1-" + data?.traineeship?.field_tr_status] ?
                    "action-" + StatusActionPair["traineeship-typeOfStudent-1-" + data?.traineeship?.field_tr_status] : "")
                    }`}>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                                <th style={{ paddingTop: 15, paddingBottom: 2, paddingLeft: 24 }} className='border-hidden label-style'>ID</th>
                                <th style={{ paddingTop: 15, paddingBottom: 2 }} className='border-hidden label-style'>{t('status')}</th>
                                <th style={{ paddingTop: 15, paddingBottom: 2 }} className='border-hidden label-style'>{t('plannedPeriod')}</th>
                                <th style={{ paddingTop: 15, paddingBottom: 2 }} className='border-hidden label-style'>{t('created')}</th>
                                <th className='download-wrap border-hidden'></th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                                <td style={{ paddingTop: 0, paddingBottom: 20, paddingLeft: 24 }} className='border-hidden body'>{data?.traineeship?.traineeship_id || ''}</td>
                                <td style={{ paddingTop: 0, paddingBottom: 20 }} className='border-hidden body'>{StatusMapping[data?.traineeship?.field_tr_status] || ''}</td>
                                <td style={{ paddingTop: 0, paddingBottom: 20 }} className='border-hidden body'>{getPlannedPeriod()}</td>
                                <td style={{ paddingTop: 0, paddingBottom: 20 }} className='border-hidden body'>{data?.traineeship?.created ? new Date(data?.traineeship?.created).toLocaleDateString() + " - " + new Date(data?.traineeship?.created).toLocaleTimeString() : ''}</td>
                                <td style={{ paddingTop: 0, marginTop: -5 }} className="download-wrap border-hidden">
                                    <Link to={`/traineeships/outgoing/export/${data?.traineeship?.traineeshipID}`} target="_blank">
                                        <IconButton
                                            variant="download"
                                            title={t('downloadPdf')}
                                        />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            }
        </>
    )
}

export default TraineeshipInfoTable;